/**
 * Pinia SSR Plugin for Nuxt 2
 * Handles proper state serialization and hydration
 */

export default function ({ app, ssrContext, beforeNuxtRender }, inject) {
  // Get the global store registry
  const globalObj = typeof window !== 'undefined' ? window : global

  if (process.server && ssrContext) {
    // Server-side: Serialize state before rendering
    beforeNuxtRender(() => {
      const stores = globalObj.__PINIA_STORES__ || {}
      const serializedState = {}

      // Collect state from all stores
      Object.entries(stores).forEach(([id, storeFactory]) => {
        if (storeFactory._instance) {
          const store = storeFactory._instance
          const state = {}

          // Serialize only data properties
          Object.keys(store).forEach((key) => {
            if (typeof store[key] !== 'function') {
              state[key] = store[key]
            }
          })

          serializedState[id] = state
        }
      })

      // Add to SSR context
      ssrContext.nuxt.pinia = serializedState
    })
  }

  if (process.client) {
    // Client-side: Restore state from SSR
    const nuxtState = window.__NUXT__

    if (nuxtState && nuxtState.pinia) {
      // Wait for next tick to ensure stores are initialized
      app.router.onReady(() => {
        const stores = globalObj.__PINIA_STORES__ || {}

        Object.entries(nuxtState.pinia).forEach(([id, state]) => {
          const storeFactory = stores[id]
          if (storeFactory) {
            const store = storeFactory()
            // Restore state
            Object.assign(store, state)
          }
        })

        // Clear the state to prevent memory leaks
        delete nuxtState.pinia
      })
    }
  }

  // Helper to check if running during SSR hydration
  inject('isHydrating', () => {
    return process.client && window.__NUXT__ && window.__NUXT__.pinia
  })
}
